const selectors = {
  component: '.c-stats-block',
  item: '.c-stats-block-item',
}

export class StatsBlock {
  constructor($el) {
    const reducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true

    if (reducedMotion) return

    this.component = $el
    const items = this.component.querySelectorAll(selectors.item)

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }

    const callback = (entries) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting) {
          this.animate(entry.target)
          entry.target.classList.add('has-transition-active')
          return
        }
        entry.target.classList.remove('has-transition-active')
      })
    }

    const observer = new IntersectionObserver(callback, options)

    items.forEach(item => {
      item.classList.add('has-transition')
      observer.observe(item)
    })
  }

  animate(obj) {
      const element = obj.querySelector(`${selectors.item}__value`)
      const start = 0
      const targetValue = element.getAttribute('data-value')
      const format = element.getAttribute('data-format')
      const duration = this.component.getAttribute('data-animation-duration') || 1600 // miliseconds
      const locale = this.getCurrentLanguage()
      let startTimestamp = null

      let options = {}

      if (this.hasDecimals(targetValue)) {
        const decimalStr = targetValue.toString().split('.')[1];

        options = {
          minimumFractionDigits: decimalStr.length,
          maximumFractionDigits: decimalStr.length
        }
      } else {
        options = {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }
      }

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)
        const value = progress * (targetValue - start) + start
        element.innerHTML = this.formatNumber(value, format, locale, options)
       
        if (progress < 1) {
          requestAnimationFrame(step)
        }
      }
      requestAnimationFrame(step)
    }

    hasDecimals(value) {
      return (value % 1 != 0) ? true : false
    }

    formatNumber(number, format, locale, options) {
      switch(format) {
        case 'p0' :
           // 81%
          return number.toLocaleString(locale, options) + '%'

        case 'p2' :
          // 81,00%
          options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }

          return number.toLocaleString(locale, options) + '%'
        case 'M' :
          // 1.220M
          return  (number/1000/1000).toLocaleString(locale, options) + 'M'
        case 'K' :
          // 30K
          return  (number/1000).toLocaleString(locale, options) + 'K'
        case 'N2' :
          // 31,000.00
          options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }

          return  number.toLocaleString(locale, options)
        default :
          return number.toLocaleString(locale, options)
      }
    }

    getCurrentLanguage() {
      const currentLang = document.querySelector('html').getAttribute('lang') || 'en'

      switch(currentLang) {
        case 'nl' :
          return 'nl-NL'
        case 'fr' :
            return 'fr-BE'
        default :
            return 'en'
      }
    }
}

document.querySelectorAll(selectors.component).forEach($el => new StatsBlock($el))
